import React, { useState, memo, useCallback, useEffect } from 'react';
import PdfDropdown from './Dropdown';
import PdfRadio from './Radio';
import PdfTextMultiline from './TextMultiline';
import PdfDate from './Date';
import PdfSignature from './Signature';
import PdfInitials from './Initials';

const PdfInput = memo(({ page,inputId, value, onChange, place_holder }) => {
  const [inputValue, setInputValue] = useState('');

  // Sync internal state with parent value prop
  useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  const handleInputChange = useCallback((event) => {
    const newValue = event.target.value;
    setInputValue(newValue);
    onChange(page,inputId,newValue)
  }, [page, inputId, onChange]);

  return (
    <div className="pdf-input">
      <input
        type="text"
        placeholder={place_holder}
        value={inputValue}
        onChange={handleInputChange}
      />
    </div>
  );
});

export {
  PdfInput,
  PdfDropdown,
  PdfRadio,
  PdfTextMultiline,
  PdfDate,
  PdfSignature,
  PdfInitials
};

export default PdfInput;
